// extracted by mini-css-extract-plugin
export default {"contentDiv":"MutualFundDetailCard_contentDiv__ae0UA","itemHeader":"MutualFundDetailCard_itemHeader__8r+qh","itemText":"MutualFundDetailCard_itemText__iCPoD"};